import {
  axios
} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findOrgProductOffline({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`orgProductOffline/findOrgProductOffline`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addProductOffline({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`orgProductOffline/addProductOffline`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findById({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`orgProductOffline/findById`, {
          params
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveOrgProductOffline({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`orgProductOffline/saveOrgProductOffline`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  generateQRUrl({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`orgProductOffline/generateQRUrl`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getAccountNo({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`orgProductOffline/getAccountNo`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
